<template>
  <el-row :gutter="20">
    <el-col v-for="(skeleton, skeleton_key) in module_skeletons" :key="skeleton_key" v-bind="skeleton.props.col">
      <el-card :body-style="{ padding: 0 }" shadow="never" class="mb-20">
        <div slot="header" class="w-full flex justify-between items-center">
          <h2 class="m-0">{{ skeleton.title }}</h2>
        </div>
        <el-empty v-bind="empty_config.props" />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getModuleSkeleton } from '@/views/fusion/investment/intelligence-create/strategy/FieldStrategy';

export default {
  data() {
    return {
      module_skeletons: Object.freeze(getModuleSkeleton()),
      empty_config: {
        props: {
          description: '暂无配置',
        },
      },
    };
  },
};
</script>
